<template>
  <div class="page-template" v-loading="loading">
    <!--    <div class="page-title">{{title}}</div>-->

    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="批发商品汇总" name="wholesaleGoodsSum">
        <search-form-template
          :searchOptions="wholesaleGoodsSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(1)"
        ></search-form-template>
        <table-template
          ref="wholesaleGoodsSum"
          :tableOptions="wholesaleGoodsTable">
        </table-template>
      </el-tab-pane>
      <el-tab-pane label="批发单据汇总" name="wholesaleBillSum">
        <search-form-template
          :searchOptions="wholesaleBillSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(2)"
        ></search-form-template>
        <table-template
          ref="wholesaleBillSum"
          :tableOptions="wholesaleBillTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="仓库批发汇总" name="storeWholesaleSum">
        <search-form-template
          :searchOptions="storeWholesaleSumSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(3)"
        ></search-form-template>
        <table-template
          ref="storeWholesaleSum"
          :tableOptions="storeWholesaleSumTable"></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import searchFormTemplate from '@/components/template/searchFormTemplate';
import tableTemplate from '@/components/template/tableTemplate';
import api from '@/config/api';
import userPower from '@/mixin/userPower';

export default {
  mixins: [userPower],
  name: 'RoleManager',
  components: {
    tableTemplate,
    searchFormTemplate
  },
  data() {
    return {
      activeTab: 'wholesaleGoodsSum',
      loading: false,
      treeConfig: {
        id: 'menuTree',
        showCheckbox: true,
        data: [],
        nodeKey: 'id',
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        request: {
          api: api.system.rolePrivilege,
          param: {roleId: ''}
        }
      },
      // 批发商品汇总高级查询
      wholesaleGoodsSearchOptions: {
        simple: [
          {
            label: '',
            prop: 'otherName',
            type: 'input',
            span: 6,
            isFuzzy: true,
            placeholder: '请输入商品名称/条码'
          }

        ],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24
          },
          {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            data: [],
            span: 6,
            isHasAll: true,
            url: api.system.seStore,
            change: this.getBrandSupplier
          },
          {
            label: '品牌',
            type: 'select',
            prop: 'goodsBrandId',
            data: [],
            span: 6
          },
          {
            label: '供应商',
            type: 'select',
            prop: 'supplierId',
            data: [],
            span: 6
          },
          {
            label: '类别',
            type: 'cascaderMultiple',
            prop: 'goodsCategoryIds',
            valueKey: 'value',
            data: [],
            span: 6,
            change: this.typeChange,
            url: api.archives.getCategoryTree
          },
          // {
          //   label: '条码',
          //   prop: 'goodsBarCode',
          //   type: 'input',
          //   span: 6,
          //   isFuzzy: true
          // },
          {
            label: '客户名称',
            prop: 'wholesaleCustomerId',
            type: 'select',
            span: 6,
            data: [],
            url: api.wholesale.archives
          }
          // {
          //   label: '客户名称',
          //   prop: 'wholesaleCustomerName',
          //   type: 'input',
          //   span: 6,
          //   isFuzzy: true
          // },
          // {
          //   label: '客户编码',
          //   prop: 'wholesaleCustomerCode',
          //   type: 'input',
          //   span: 6,
          //   isFuzzy: true
          // },
          // {
          //   label: "金额区间",
          //   prop: "Value",
          //   type: "numberRange",
          //   span: 12,
          // },
        ]
      },
      // 批发单据汇总高级查询
      wholesaleBillSearchOptions: {
        simple: [
          {
            label: '请输入业务单号',
            prop: 'orderNo',
            type: 'input',
            ifFuzzy: true,
            placeholder: '请输入业务单号'
          }
        ],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24
          },
          // {
          //   label: '批发级别',
          //   type: 'select',
          //   prop: 'relateType',
          //   data: this.$utils.getCacheStatus("pcPurchaseStorageOrder.relateType"),
          //   span: 12,
          //   change: this.getBillStoreChange,
          //   hidden: true,
          // },
          {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            data: [],
            span: 8,
            isHasAll: true,
            // hidden: true,
            url: api.system.seStore
          },
          {
            label: '客户名称',
            prop: 'wholesaleCustomerId',
            type: 'select',
            span: 8,
            data: [],
            url: api.wholesale.archives
          },
          {
            label: '单据类型',
            prop: 'wholesaleType',
            type: 'select',
            span: 8,
            data: [
              {label: '批发退货单', value: 60},
              {label: '批发销售单', value: 50}
            ]
          }
          // {
          //   label: '单号',
          //   prop: 'orderNo',
          //   type: 'input',
          //   span: 8,
          //   // isFuzzy: true,
          //   placeholder: '请输入单号',
          //   inputWidth:'250px'
          // }
        ]
      },
      // 批发仓库汇总高级查询
      storeWholesaleSumSearchOptions: {
        simple: [
          // {
          //   label: '门店名称',
          //   type: 'select',
          //   prop: 'wholesaleStoreId',
          //   data: [],
          //   span: 12,
          //   isHasAll: true,
          //   url: api.store.store,
          //   // hidden: true,
          //   // change: this.getStoreNameChange,
          // },
        ],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24
          },
          {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            data: [],
            span: 8,
            isHasAll: true,
            change: this.changeStore,
            url: api.system.seStore
          },
          {
            label: '仓库名称',
            prop: 'warehouseId',
            type: 'select',
            span: 12,
            // param: {relateType: this.$utils.getSysUser().type},
            data: []
            // url: api.warehouse.warehouse,
          }
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '打印',
          code: 'print'
        },
        {
          label: '导出',
          code: 'export',
          callback: this.exportExcel
        }
      ],
      // 批发商品汇总
      wholesaleGoodsTable: {
        showSummary: true,
        summaryColumns: ['goodsCount', 'discountAmt', 'returnNum', 'returnAmt', 'giveNum', 'remainingNum', 'discountRemainingAmt'],
        param: {},
        indexShow: true, // 是否显示索引
        indexMethod: (index) => { // 自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '条码',
            prop: 'goodsBarCode',
            width: '190',
            align: 'center'
          },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '150',
            align: 'center'
          },
          {
            label: '仓库名称',
            prop: 'storeName',
            width: '300',
            align: 'center'
          },
          {
            label: '销售数量',
            prop: 'goodsCount',
            width: '120',
            align: 'center'
          },
          {
            label: '销售金额',
            prop: 'discountAmt',
            width: '120',
            align: 'center'
          },
          {
            label: '退货数量',
            prop: 'returnNum',
            width: '120',
            align: 'center'
          },
          {
            label: '退货金额',
            prop: 'returnAmt',
            width: '120',
            align: 'center'
          },
          {
            label: '赠送数量',
            prop: 'giveNum',
            width: '120',
            align: 'center'
          },
          {
            label: '小计数量',
            prop: 'remainingNum',
            width: '120',
            align: 'center'
          },
          {
            label: '小计金额',
            prop: 'discountRemainingAmt',
            width: '120',
            align: 'center'
          },
          {
            label: '供应商名称',
            prop: 'supplierName',
            width: '150',
            align: 'center'
          },
          {
            label: '类别',
            prop: 'goodsCategoryName',
            width: '190',
            align: 'center'
          },
          {
            label: '品牌',
            prop: 'goodsBrandName',
            width: '150',
            align: 'center'
          }
        ],
        url: api.wholesale.wholesaleGoods
      },
      // 批发单据汇总
      wholesaleBillTable: {
        showSummary: true,
        summaryColumns: ['totalAmt'],
        param: {},
        indexShow: true, // 是否显示索引
        indexMethod: (index) => { // 自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
            width: '260',
            align: 'center',
            callback: this.goOrderDetail
          },
          {
            label: '仓库名称',
            prop: 'storeName',
            width: '300',
            align: 'center'
          },
          {
            label: '客户编码',
            prop: 'wholesaleCustomerCode',
            width: '150',
            align: 'center'
          },
          {
            label: '客户名称',
            prop: 'wholesaleCustomerName',
            width: '150',
            align: 'center'
          },
          {
            label: '单据类型',
            prop: 'wholesaleType',
            width: '120',
            align: 'center',
            enumData: this.$utils.getCacheStatus('wlWholesaleOrderGoodsMap.wholesaleType')
          },
          {
            label: '审核状态',
            prop: 'reviewerStatus',
            width: '120',
            align: 'center',
            enumData: this.$utils.getCacheStatus('wlWholesaleReturnOrder.reviewerStatus')
          },
          // {
          //   label: '经手人姓名',
          //   prop: 'salesman',
          //   width: '150',
          //   align: 'center'
          // },
          {
            label: '单据金额(元)',
            prop: 'totalAmt',
            width: '120',
            align: 'center'
          },

          {
            label: '制单人',
            prop: 'voucherName',
            width: '150',
            align: 'center'
          },
          {
            label: '制单日期',
            prop: 'voucherDttm',
            width: '150',
            align: 'center'
          },
          {
            label: '审核人',
            prop: 'reviewerName',
            width: '150',
            align: 'center'
          },
          {
            label: '审核日期',
            prop: 'reviewerDttm',
            width: '150',
            align: 'center'
          },
          {
            label: '备注',
            prop: 'remarks',
            width: '150',
            align: 'center'
          }
        ],
        url: api.wholesale.wholesaleBills
      },
      // 仓库批发汇总
      storeWholesaleSumTable: {
        showSummary: true,
        summaryColumns: ['wholesaleNum', 'totalAmt', 'returnNum', 'returnAmt', 'giveNum', 'subtotalNum', 'subtotalAmt'],
        param: {},
        indexShow: true, // 是否显示索引
        indexMethod: (index) => { // 自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '仓库名称',
            prop: 'storeName',
            width: '300',
            align: 'center'
          },
          {
            label: '销售数量',
            prop: 'wholesaleNum',
            width: '150',
            align: 'center'
          },
          {
            label: '销售金额',
            prop: 'totalAmt',
            width: '150',
            align: 'center'
          },
          {
            label: '退货数量',
            prop: 'returnNum',
            width: '150',
            align: 'center'
          },
          {
            label: '退货金额',
            prop: 'returnAmt',
            width: '150',
            align: 'center'
          },
          {
            label: '赠送数量',
            prop: 'giveNum',
            width: '150',
            align: 'center'
          },
          // {
          //   label: '赠送金额',
          //   prop: 'giveAmt',
          //   width: '150',
          //   align: 'center'
          // },
          {
            label: '小计数量',
            prop: 'subtotalNum',
            width: '150',
            align: 'center'
          },
          {
            label: '小计金额',
            prop: 'subtotalAmt',
            width: '150',
            align: 'center'
          }
        ],
        url: api.wholesale.wholesaleStore
      },

      salesDetailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '100px',
          top: '0',
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
          },
          {
            label: "批发门店",
            prop: "storeName",
          },
          {
            label: '批发客户',
            prop: 'wholesaleCustomerName',
          }, {
            label: '仓库',
            prop: 'warehouseName',
          }, {
            label: '经手人',
            prop: 'salesman',
          }, {
            label: '备注',
            prop: 'remarks',
          }],
        tablesProp: {
          wlWholesaleOrderGoodsMapList: {
            url: api.wholesale.wholesaleQuery + "/page",
            height: this.detailHeight,
            indexShow: true,
            showSummary: true,
            summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
            tableName: "wlWholesaleOrderGoodsMapList",
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '125',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '数量',
                width: '90',
                prop: 'goodsCount',
                align: "center"
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsCount',
                align: "center"
              },
              {
                label: '原价',
                width: '90',
                prop: 'beforePrince',
                align: "center"
              },
              {
                label: '原价金额',
                width: '90',
                prop: 'beforeAmt',
                align: "center"
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: "center"
              },
              {
                label: '折扣价格',
                width: '90',
                prop: 'discountPrince',
                align: "center"
              },
              {
                label: '小计金额',
                width: '90',
                prop: 'discountAmt',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          }
        },

        // 打印的列表
        printTablesProp: {
          wlWholesaleOrderGoodsMapList: {
            tableName: 'wlWholesaleOrderGoodsMapList',
            showSummary: true,
            summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
            columns: [
              {
                label: '序号',
                prop: 'indexShow',
                width: '50',
                align: "center"
              },
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '125',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '数量',
                width: '90',
                prop: 'goodsCount',
                align: "center"
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsCount',
                align: "center"
              },
              {
                label: '原价',
                width: '90',
                prop: 'beforePrince',
                align: "center"
              },
              {
                label: '原价金额',
                width: '90',
                prop: 'beforeAmt',
                align: "center"
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: "center"
              },
              {
                label: '折扣价格',
                width: '90',
                prop: 'discountPrince',
                align: "center"
              },
              {
                label: '小计金额',
                width: '90',
                prop: 'discountAmt',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          },
        },
        url: api.wholesale.wholesaleSales
      },
      returnDetailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '100px',
          top: '0',
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
          },
          {
            label: "批发门店",
            prop: "storeName",
          }, {
            label: '批发客户',
            prop: 'wholesaleCustomerName',
          }, {
            label: "仓库",
            prop: "warehouseName",
          }, {
            label: '经手人',
            prop: 'salesman',
          },
          {
            label: '批发销售单',
            type: 'select',
            prop: 'wholesaleOrderNo',
          }, {
            label: '备注',
            prop: 'remarks',
          }],
        tablesProp: {
          wlWholesaleOrderGoodsMapList: {
            url: api.wholesale.wholesaleQuery + "/page",
            height: this.detailHeight,
            indexShow: true,
            showSummary: true,
            tableName: "wlWholesaleOrderGoodsMapList",
            summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '125',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '数量',
                width: '90',
                prop: 'goodsCount',
                type: 'inputNumber',
                align: "center"
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsCount',
                align: "center"
              },
              {
                label: '原价',
                width: '90',
                prop: 'beforePrince',
                align: "center"
              },
              {
                label: '原价金额',
                width: '90',
                prop: 'beforeAmt',
                align: "center"
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: "center"
              },
              {
                label: '折扣价格',
                width: '90',
                prop: 'discountPrince',
                align: "center"
              },
              {
                label: '小计金额',
                width: '90',
                prop: 'discountAmt',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          }
        },

        // 打印的列表
        printTablesProp: {
          wlWholesaleOrderGoodsMapList: {
            tableName: 'wlWholesaleOrderGoodsMapList',
            showSummary: true,
            summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '125',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '数量',
                width: '90',
                prop: 'goodsCount',
                type: 'inputNumber',
                align: "center"
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsCount',
                align: "center"
              },
              {
                label: '原价',
                width: '90',
                prop: 'beforePrince',
                align: "center"
              },
              {
                label: '原价金额',
                width: '90',
                prop: 'beforeAmt',
                align: "center"
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: "center"
              },
              {
                label: '折扣价格',
                width: '90',
                prop: 'discountPrince',
                align: "center"
              },
              {
                label: '小计金额',
                width: '90',
                prop: 'discountAmt',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          },
        },
        url: api.wholesale.wholesaleReturn
      }
    };
  },
  created() {
    this.title = document.title;
    this.setStore(this.wholesaleGoodsSearchOptions.complex);
    this.setStore(this.wholesaleBillSearchOptions.complex);
    this.setStore(this.storeWholesaleSumSearchOptions.complex);
    // if (this.$utils.getSysUser().storeId) {
    //   this.wholesaleBillSearchOptions.complex.filter(v => v.prop === 'wholesaleStoreId')[0].hidden = true
    //   this.wholesaleGoodsSearchOptions.complex.filter(v => v.prop === 'wholesaleStoreId')[0].hidden = true
    // } else {
    //   this.wholesaleBillSearchOptions.complex.filter(v => v.prop === 'wholesaleStoreId')[0].hidden = false
    //   this.wholesaleGoodsSearchOptions.complex.filter(v => v.prop === 'wholesaleStoreId')[0].hidden = false
    // }
  },
  mounted() {
    this.getStoreBrandSup()
    this.getWarehouseId()
    // this.setWholeasleRelateType(this.storeWholesaleSumSearchOptions.simple);
  },
  methods: {
    // 选择门店
    changeStore(form) {
      form.warehouseId = ''
      let warehouseId = this.storeWholesaleSumSearchOptions.complex.filter(v => v.prop === 'warehouseId')[0]
      // 仓库数据
      this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: form.storeId}).then(res => {
        if (res.code === 200 && res.data) {
          warehouseId.data = res.data
        }
      })
    },
    getWarehouseId() {
      let userInfo = this.$utils.getSysUser()
      let warehouseId = this.storeWholesaleSumSearchOptions.complex.filter(v => v.prop === 'warehouseId')[0]
      if (userInfo.storeId) {
        // 仓库数据
        this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: userInfo.storeId}).then(res => {
          if (res.code === 200 && res.data) {
            warehouseId.data = res.data
          }
        })
      }
    },
    goOrderDetail(row) {
      if (row.wholesaleType === 50) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.salesDetailColumns);
        const {href} = this.$router.resolve({
          name: 'SalesDetail',
          query: {id: row.wholesaleId}
        });
        window.open(href, '_blank');
      } else {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.returnDetailColumns);
        const {href} = this.$router.resolve({
          name: 'wholeasleReturnDetail',
          query: {id: row.wholesaleId}
        });
        window.open(href, '_blank');
      }
    },
    tabChange() {
      this.$refs[this.activeTab].operationSuccess();
    },
    searchSubmit(param) {
      console.log(param)
      this.$refs[this.activeTab].searchParam = param;
      this.$refs[this.activeTab].operationSuccess();
    },
    clearSearch() {
      this.$refs['wholesaleGoodsSum'].clearSearch();
      this.$refs['wholesaleBillSum'].clearSearch();
      this.$refs['storeWholesaleSum'].clearSearch();
      let userInfo = this.$utils.getSysUser();
      if (!userInfo.storeId) {
        this.wholesaleGoodsSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
        this.wholesaleGoodsSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
        this.storeWholesaleSumSearchOptions.complex.filter(item => item.prop === 'warehouseId')[0].data = []
      }
    },
    getGoodsStoreChange(form) {
      if (form.relateType === 20) {
        this.wholesaleGoodsSearchOptions.simple.filter(item => item.prop === 'wholesaleStoreId')[0].hidden = false;
      } else {
        this.wholesaleGoodsSearchOptions.simple.filter(item => item.prop === 'wholesaleStoreId')[0].hidden = true;
      }
    },
    getStoreBrandSup() {
      let userInfo = this.$utils.getSysUser();
      if (userInfo.storeId) {
        this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: userInfo.storeId}).then(data => {
          if (data.code === 200) {
            this.wholesaleGoodsSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
          }
        });
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: userInfo.storeId}).then(data => {
          if (data.code === 200) {
            this.wholesaleGoodsSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          }
        })
      }
    },
    getBrandSupplier(form) {
      form.goodsBrandId = ''
      form.supplierId = ''
      this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.wholesaleGoodsSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
        }
      });
      this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.wholesaleGoodsSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
        }
      })
    },
    getBillStoreChange(form) {
      if (form.relateType === 20) {
        this.wholesaleBillSearchOptions.simple.filter(item => item.prop === 'wholesaleStoreId')[0].hidden = false;
      } else {
        this.wholesaleBillSearchOptions.simple.filter(item => item.prop === 'wholesaleStoreId')[0].hidden = true;
      }
    },
    getSumStoreChange(form) {
      if (form.relateType === 20) {
        form.warehouseId = '';
        form.wholesaleStoreId = '';
        this.storeWholesaleSumSearchOptions.simple.filter(item => item.prop === 'warehouseId')[0].data = [];
        this.storeWholesaleSumSearchOptions.simple.filter(item => item.prop === 'wholesaleStoreId')[0].hidden = false;
        this.$axios.fetchPost(api.system.seStore + '/list', {}).then(data => {
          this.storeWholesaleSumSearchOptions.simple.filter(item => item.prop === 'wholesaleStoreId')[0].data = data.data
        })
      } else if (form.relateType === 10) {
        form.warehouseId = ''
        this.$axios.fetchPost(api.warehouse.warehouse + '/warehouse/list', {relateType: form.relateType}).then(data => {
          if (data.code == 200) {
            this.storeWholesaleSumSearchOptions.simple.filter(item => item.prop === 'warehouseId')[0].data = data.data;
          }
        })
        this.storeWholesaleSumSearchOptions.simple.filter(item => item.prop === 'wholesaleStoreId')[0].hidden = true;
      }
    },
    getStoreNameChange(form) {
      this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: form.wholesaleStoreId}).then(data => {
        if (data.code === 200) {
          form.warehouseId = ''
          this.storeWholesaleSumSearchOptions.simple.filter(item => item.prop === 'warehouseId')[0].data = data.data;
        }
      })
    },
    exportExcel(param) {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let params, url, fileName;
      if (param === 1) {
        params = this.$refs['wholesaleGoodsSum'].searchParam;
        url = api.wholesale.wholesaleGoodsExport;
        fileName = '批发商品汇总_';
      } else if (param === 2) {
        params = this.$refs['wholesaleBillSum'].searchParam;
        url = api.wholesale.wholesaleBillsExport;
        fileName = '批发单据汇总_';
      } else if (param === 3) {
        params = this.$refs['storeWholesaleSum'].searchParam;
        url = api.wholesale.wholesaleStoreExport;
        fileName = '仓库批发汇总_';
      }
      this.$axios.PostBlob(url, params).then(res => {
        if (res.status === 200) {
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName + this.$utils.getDateTime() + ".xlsx"; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          // this.$message.success("导出成功,文件名称:" + fileName);
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    }
  }
}
</script>

<style scoped>
.page-template {
  padding-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/page/wholeasle/query.vue